var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 27"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.882 23.891c-6.156 0-11.164-4.823-11.164-10.75 0-5.929 5.008-10.751 11.164-10.751s11.164 4.822 11.164 10.75-5.008 10.75-11.164 10.75m0-23.155C5.779.735 0 6.3 0 13.14c0 6.84 5.779 12.405 12.882 12.405S25.764 19.98 25.764 13.14C25.764 6.3 19.985.735 12.882.735"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.74 6.938h-1.717v5.376H6.441v1.653h5.582v5.376h1.717v-5.376h5.583v-1.653H13.74z"
  }))));
};

export default SvgPlusCircle;